import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { useAuth0 } from '@auth0/auth0-react';
import Logo from '../../assets/logo.svg';
import HomeBackgroundImage from '../../assets/home_bg.jpg';														   
import { Col, Layout, Menu, Row } from 'antd';
import { RouteDefinition } from '../../core/route';
import { useNavigate, Link, Outlet } from 'react-router-dom';
import { getLink } from '../../App-router';
import { MenuInfo } from 'rc-menu/lib/interface';
import { DefaultLinkName } from '../../core/defaults';
import { LogoutOutlined } from '@ant-design/icons';

const { Header, Footer, Content } = Layout;

interface AppLayoutProps {
  children?: any | undefined;
  getRoutes?(): RouteDefinition[];
}

export default function AppLayout(props: AppLayoutProps) {
  const auth0 = useAuth0();
  const routes: RouteDefinition[] = props.getRoutes ? props.getRoutes()[0].children! : [];
  const [selectedMenuItem, setSelectedMenuItem] = useState(DefaultLinkName);

  const navigate = useNavigate();

  const handleMenuClick = useCallback(
    (e: MenuInfo) => {
      const menuLink = getLink(e.key, {});
      setSelectedMenuItem(e.key);
      navigate(menuLink);
    },
    [navigate]
  );



  return (
    <Layout className="layout">
      <Header style={{
        height: 'auto',
        lineHeight: 1.5,
        backgroundColor: '#ffffff'
      }}>
        <Row gutter={16} style={{ padding: '1rem 0' }} justify="space-between" align="middle">
          <Col>
            <Link to={getLink('PartnershipInformationList', {})} style={{ backgroundColor: '#ffffff', padding: '0.25rem 0.5rem', borderRadius: '0.25rem', display: 'block' }}>
              <img src={Logo} alt="Logo" />
            </Link>
          </Col>
          <Col flex="auto">
          </Col>

          <Col>
            <LogoutOutlined style={{ color: '#000000', fontSize: '24px' }}
              onClick={() => auth0.logout({ logoutParams: { returnTo: window.location.origin } })}
            />
          </Col>
        </Row>
      </Header>
      <Layout style={{ padding: '16px 50px', background: `#ffffff url(${HomeBackgroundImage}) bottom right/cover no-repeat` }}>
      <Content
        className="site-layout-background" style={{ minHeight: '88vh' }}
      >
        <Outlet />
      </Content>
      </Layout>
      <Footer style={{ textAlign: 'center' }} />
    </Layout>
  );
}

AppLayout.propTypes = {
  children: PropTypes.any,
};
